export default __webpack_public_path__ + "static/media/MLT.4ff6aff2.svg";